<template>
  <v-container fluid>
    <v-card flat raised elevation="5" style="width: 100%">
      <v-card-text class="pa-0">
        <v-row>
          <v-col cols="12" sm="12" md="12" class="pa-0">
            <v-row no-gutters v-resize="onResize">
              <ejs-splitter
                id="splitter"
                ref="splitterObj"
                :separatorSize="1"
                class="splitterContent"
                width="100%"
                :height="screenHeight"
              >
                <e-panes>
                  <e-pane
                    cssClass="overflow-y-hidden list-pane"
                    size="30%"
                    :collapsible="false"
                    :collapsed="false"
                    content="#meeting-list-content"
                    min="20%"
                  ></e-pane>
                  <e-pane
                    cssClass="overflow-y-hidden overflow-x-hidden table-pane"
                    size="70%"
                    min="50%"
                    content="#meeting-permission-content"
                  ></e-pane>
                </e-panes>
              </ejs-splitter>
              <div id="meeting-list-content">
                <v-toolbar
                  tile
                  flat
                  height="50"
                  color="neutralGray"
                  style="
                    color: #ffffff !important;
                    border-bottom: 1px solid var(--v-secondary-base) !important;
                  "
                >
                  <v-row
                    class="d-flex justify-space-between"
                    style="align-items: center"
                  >
                    <span class="mr-auto title"> {{ $t("meetings") }} </span>
                    <a-btn
                      small
                      text
                      dark
                      class="btn-gray-theme mr-2"
                      @click.stop="sortingMeetings()"
                    >
                      <span>
                        {{ $t("documents.lblDate") }}
                        <v-icon
                          v-if="sortingType === 'ascending'"
                          size="16"
                          color="#FFFFFF"
                          >mdi-arrow-up</v-icon
                        >
                        <v-icon v-else size="16" color="#FFFFFF"
                          >mdi-arrow-down</v-icon
                        >
                      </span>
                    </a-btn>
                    <meeting-filter
                      section="document"
                      @isLoader="isLoader"
                      :isSmall="true"
                    ></meeting-filter>
                  </v-row>
                </v-toolbar>
                <v-skeleton-loader
                  v-if="loaderLoading"
                  type="list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item, list-item"
                ></v-skeleton-loader>
                <a-list
                  v-else
                  :height="listHeight"
                  class="meeting-list list-margin pt-0"
                  style="overflow: auto"
                >
                  <v-list-item-group
                    v-model="selectedItemIndex"
                    color="primary"
                  >
                    <v-list-item
                      v-for="(meetingItem, i) in sortedMeetings"
                      :key="i"
                      @click="onMeetingClick(meetingItem)"
                    >
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-list-item-content v-on="on" v-bind="attrs">
                            <v-list-item-title>
                              {{ meetingItem.meetingName }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ getDay(meetingItem.scheduletStartTimeInUTC) }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                        <span> {{ meetingItem.meetingName }} </span><br />
                        <span>
                          {{ getDay(meetingItem.scheduletStartTimeInUTC) }}
                        </span>
                      </v-tooltip>

                      <v-row class="px-2">
                        <v-list-item-action>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-list-item-icon v-bind="attrs" v-on="on">
                                <v-icon> mdi-attachment </v-icon>
                                <v-list-item-action-text>{{
                                  getAllDocumentsCount(meetingItem)
                                }}</v-list-item-action-text>
                              </v-list-item-icon>
                            </template>
                            <span>
                              {{
                                $t("documents.tipMeetingDocContains", {
                                  count: getAllDocumentsCount(meetingItem),
                                })
                              }}
                            </span>
                          </v-tooltip>
                        </v-list-item-action>
                      </v-row>
                    </v-list-item>
                  </v-list-item-group>
                </a-list>
              </div>
              <div id="meeting-permission-content">
                <v-toolbar color="secondary" height="50" flat dense dark>
                  <v-row
                    style="
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      align-items: center;
                    "
                  >
                    <v-col cols="12" sm="8" md="8"></v-col>
                    <v-col cols="12" sm="4" md="4" style="padding-left: 4%">
                      <search-input v-model="search" :label="$t('lblSearchTextDocumentMeeting')" :labelTooltip="$t('lblSearchTextDocumentMeetingTooltip')"></search-input>
                    </v-col>
                  </v-row>
                </v-toolbar>
                <v-row
                  class="py-4 px-4"
                  style="
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <v-col cols="12" sm="3" md="3">
                    <v-tooltip
                      bottom
                      v-if="
                        selectedMeeting &&
                        $security.checkMeetingTypeAccess(
                          selectedMeeting.meetingTypeId,
                          'OpenMeetingDocument'
                        )
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <a-btn
                          v-bind="attrs"
                          v-on="on"
                          text
                          dark
                          v-if="
                            $security.checkMeetingTypeAccess(
                              selectedMeeting.meetingTypeId,
                              'OpenMeetingDocument'
                            )
                          "
                          :class="
                            selectedFiles.length > 0
                              ? 'primaryDark'
                              : 'secondary'
                          "
                          :disabled="selectedFiles.length > 0 ? false : true"
                          :style="
                            selectedFiles.length > 0
                              ? ''
                              : 'color: #EEEEEE !important'
                          "
                          @click.stop="downloadDocument"
                        >
                          <v-icon
                            left
                            :style="
                              selectedFiles.length > 0
                                ? ''
                                : 'color: #FFFFFF !important'
                            "
                            >mdi-download</v-icon
                          >
                          {{ $t("documents.download") }}
                        </a-btn>
                      </template>
                      <span>{{ $t("documents.tipDownload") }}</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"></v-col>
                  <v-col
                    cols="12"
                    sm="3"
                    md="3"
                    class="text-right"
                    style="margin: auto"
                  >
                    <v-chip
                      v-if="selectedFiles.length > 0"
                      close
                      label
                      color="primaryDark"
                      dark
                      @click:close="selectedFiles = []"
                      >{{ selectedFiles.length }}
                      {{ $t("documents.itemsSelected") }}
                    </v-chip>
                  </v-col>
                </v-row>
                <v-skeleton-loader
                  v-if="loadingDocuments"
                  type="table-thead, table-tbody"
                ></v-skeleton-loader>
                <meeting-documents-list-view
                  v-else
                  :files="documentsItems"
                  :search="search"
                  v-model="selectedFiles"
                  :loading="isDataLoading"
                  :height="listHeight"
                  :defaultSortOrder="defaultSortOrder"
                ></meeting-documents-list-view>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="documentUploadDialog" persistent max-width="600px">
      <v-card flat>
        <v-toolbar color="pageHeader" flat dark height="50px">
          <v-btn icon large>
            <v-icon>mdi-cloud-upload</v-icon>
          </v-btn>

          <span>{{ $t("documents.uploadDocument") }}</span>
        </v-toolbar>
        <v-card-text v-cloak @drop.prevent="addDropFile" @dragover.prevent>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-combobox
                    v-model="selectedTopics"
                    :items="topicItems"
                    :rules="[(v) => !!v || $t('documents.topicRequired')]"
                    required
                    item-text="topicName"
                    item-value="Id"
                    :label="$t('documents.selectTopics')"
                  ></v-combobox>
                  <upload-file
                    :files="uploadingFiles"
                    :icons="fileIcons"
                    @add-files="addUploadingFiles"
                    @remove-file="removeUploadingFile"
                  ></upload-file>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="pageHeader" text @click="onCloseDocumentUploadDialog">{{
            $t("btnClose")
          }}</v-btn>
          <v-btn
            :disabled="!valid"
            color="pageHeader"
            text
            @click="onDocumentUpload"
            >{{ $t("documents.upload") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm-dialog ref="confirm"></confirm-dialog>
  </v-container>
</template>

<script>
import MeetingDocumentsListView from "./MeetingDocumentsListView.vue";
import UploadFile from "./UploadFile.vue";
import { formatBytes, createUUID } from "../../utils/util";
import { fileIcons } from "../../utils/constant";
import { mapActions, mapState, mapGetters } from "vuex";
import ConfirmDialog from "../ConfirmDialog.vue";
import SearchInput from "../SearchInput.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
import MeetingFilter from "@/components/agenda/MeetingFilter.vue";
import Loader from "@/components/Loader";
import _ from "lodash";
import DocumentMixin from "./DocumentMixin";

export default {
  components: {
    MeetingDocumentsListView,
    UploadFile,
    ConfirmDialog,
    SearchInput,
    Loader,
    MeetingFilter,
  },
  mixins: [SignalRMixin, DocumentMixin],
  name: "DocumentByMeetings",
  data() {
    return {
      defaultSortOrder: null,
      loadingDocuments: false,
      sortedMeetingList: null,
      sortingType: "",
      loaderLoading: false,
      isDataLoading: false,
      documentsItems: [],
      selectedFiles: [],
      fileIcons,
      valid: true,
      uploadingFiles: [],
      selectedTopics: null,
      documentUploadDialog: false,
      search: "",
      selectedItemIndex: 0,
      selectedMeeting: null,
      screenHeight: 0,
      listHeight: 0,
      index: 0,
    };
  },
  computed: {
    ...gettersMap(),
    ...mapState({
      meetingListData: (state) => state.document.meetingListForDocument,
      documentsList: (state) => state.document.documentsList,
      meetingFilterData: (state) => state.meeting.default_meetting_filter,
    }),
    loaderText() {
      return this.$t("LoaderText");
    },
    topicItems() {
      return this.selectedMeeting ? this.selectedMeeting.topics : [];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    sortedMeetings() {
      if (this.meetingListData.length) {
        const meetingListData = this.meetingListData.filter((item) => {
          if (
            this.$security.checkMeetingTypeAccess(
              item.meetingTypeId,
              "ViewMeeting"
            ) &&
            this.$security.checkMeetingTypeAccess(
              item.meetingTypeId,
              "OpenMeetingDocument"
            )
          ) {
            return item;
          }
        });
        if (this.sortingType === "ascending") {
          return _.orderBy(
            meetingListData,
            ["scheduletStartTimeInUTC"],
            ["desc"]
          );
        } else if (this.sortingType === "descending") {
          return _.orderBy(
            meetingListData,
            ["scheduletStartTimeInUTC"],
            ["asc"]
          );
        } else {
          return this.meetingListData;
        }
      }
      return [];
    },
    openMeetingDocumentPermission() {
      if (this.getMeetingTypeId) {
        return this.$security.checkMeetingTypeAccess(
          this.getMeetingTypeId,
          "OpenMeetingDocument"
        );
      }
      return false;
    },
  },
  watch: {
    getFilterData(value) {
      this.sortingType = this.isMeetingTypeFilterForPast(value.filter_type)
        ? "descending"
        : "ascending";
    },
    async sortedMeetings(value) {
      if (value.length) {
        await this.bindMeetingDocuments(value);
      } else {
        this.documentsItems = [];
        this.isDataLoading = false;
        this.loadingDocuments = false;
        this.loaderLoading = false;
      }
    },
  },
  mounted,
  methods: {
    ...mapActions({
      getDocumentsList: "document/getDocumentsList",
      getDocumentsByMeetingId: "document/getDocumentsByMeetingId",
      createDocuments: "document/createDocuments",
      deleteDocuments: "document/deleteDocuments",
      downloadDocumentAPI: "document/downloadDocument",
      getMeetingListApi: "document/getMeetingListForDocument",
      setDefaultFilterApi: "meeting/setDefaultFilterType",
    }),
    onMeetingClick,
    getMeetingDescription,
    onOpenDocumentUploadDialog,
    onCloseDocumentUploadDialog,
    onDocumentUpload,
    addUploadingFiles,
    addFiles,
    formatBytes,
    removeUploadingFile,
    addDropFile,
    downloadDocument,
    getDocumentListByMeetingId,
    onDeleteDocuments,
    confirmDelete,
    createUUID,
    signalRInit,
    getAllDocumentsCount,
    sortingMeetings,
    isLoader(status) {
      this.loaderLoading = status;
      this.isDataLoading = status;
      if (status === true) {
        this.loadingDocuments = status;
      }
    },
    getDay(meetingdate) {
      let Xmas95 = new Date(meetingdate);
      let options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.$i18n.locale, options).format(Xmas95);
    },
    onResize() {
      this.screenHeight = window.innerHeight - 150;
      this.listHeight = window.innerHeight - 200;
    },
    async bindMeetingDocuments(items) {
      if (items.length) {
        this.selectedMeeting = items[this.selectedItemIndex];
        if (this.selectedMeeting) {
          await this.getDocumentListByMeetingId(this.selectedMeeting);
        } else {
          this.documentsItems = [];
          this.isDataLoading = false;
          this.loadingDocuments = false;
          this.loaderLoading = false;
        }
      }
    },
    isMeetingTypeFilterForPast(filter_type) {
      if (
        filter_type == "month" ||
        filter_type == "quarter" ||
        filter_type == "year" ||
        filter_type == "custom"
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
};
function gettersMap() {
  return mapGetters({
    getFilterData: "meeting/getFilterData",
    tenantSettingConfig: "tenant/tenantSettingConfig",
  });
}
async function sortingMeetings() {
  if (this.sortingType === "ascending") {
    this.sortingType = "descending";
  } else if (this.sortingType === "descending") {
    this.sortingType = "ascending";
  }
  this.selectedFiles = [];
  this.documentsItems = [];
  this.selectedItemIndex = 0;
}
function getAllDocumentsCount(meetingItem) {
  return meetingItem.documentCount || 0;
}
function signalRInit(target) {
  this.signalConnection.on(target, async (message) => {
    if (!_.isEmpty(message) && this.selectedMeeting) {
      await this.setDefaultFilterApi({ section: "document" });
      await this.getDocumentListByMeetingId(this.selectedMeeting);
    }
  });
  if (this.signalConnection.connectionState.toLowerCase() === "disconnected") {
    this.signalConnection.start().catch();
  }
}

async function onDeleteDocuments() {
  const answer = await this.confirmDelete();
  if (answer) {
    const promises = [];
    this.selectedFiles.forEach((files) => {
      promises.push(this.deleteDocuments(files.documentId));
    });
    await Promise.all(promises);
    await this.getDocumentListByMeetingId(this.selectedMeeting);
  }
}

function downloadDocument() {
  this.selectedFiles.forEach(async (file) => {
    const params = {
      documentId: file.documentId,
      filename: file.fileName,
    };
    const res = await this.downloadDocumentAPI(params);
    let contentType = res.headers["content-type"];
    let blob = new Blob([res.data], { type: contentType });
    let url = window.URL.createObjectURL(blob);
    let docUrl = document.createElement("a");
    docUrl.href = url;
    docUrl.setAttribute("download", file.fileName);
    document.body.appendChild(docUrl);
    docUrl.click();
  });
}
function addDropFile(e) {
  if (e.dataTransfer.files) {
    this.addFiles(e.dataTransfer.files);
  }
}

function removeUploadingFile(index) {
  this.uploadingFiles.splice(index, 1);
}

async function addFiles(files) {
  if (files.length) {
    this.addUploadingFiles(files);
    this.$refs.inputUpload.reset();
  }
}

async function addUploadingFiles(files) {
  files = Array.from(files);
  this.uploadingFiles.push(...files);
}

async function onDocumentUpload() {
  if (this.$refs.form.validate()) {
    const promises = [];
    let formData;
    this.uploadingFiles.forEach(async (item) => {
      formData = new FormData();
      formData.append("tenantId", sessionStorage.getItem("tenantId"));
      formData.append("topicId", this.selectedTopics.Id || "");
      formData.append("documentId", createUUID());
      formData.append("meetingId", this.selectedMeeting.id);
      formData.append("agendaId", "testagenda");
      formData.append("directoryId", "");
      formData.append("peopleId", "");
      formData.append("attachment", item);
      promises.push(this.createDocuments(formData));
    });
    await Promise.all(promises);
    await this.getDocumentListByMeetingId(this.selectedMeeting);
    this.$refs.form.reset();
    this.$refs.form.resetValidation();
    this.documentUploadDialog = false;
  }
}

function onOpenDocumentUploadDialog() {
  this.selectedTopics = null;
  this.uploadingFiles = [];
  this.documentUploadDialog = true;
}

function onCloseDocumentUploadDialog() {
  this.$refs.form.reset();
  this.$refs.form.resetValidation();
  this.documentUploadDialog = false;
}

async function onMeetingClick(item) {
  this.selectedFiles = [];
  this.selectedMeeting = item;
  await this.getDocumentListByMeetingId(item);
}

async function getDocumentListByMeetingId(item) {
  try {
    this.isDataLoading = true;
    this.loadingDocuments = true;
    this.selectedFiles = [];
    this.documentsItems = [];
    const documents = await this.getDocumentsByMeetingId(item.id);
    this.documentsItems = documents
      .map((doc) => ({
        ...doc,
        meetingTypeId: item.meetingTypeId,
        meetingObj: item,
      }))
      .filter((item) => !item.chatid);

    this.isDataLoading = false;
    this.loadingDocuments = false;
    this.loaderLoading = false;
  } catch (error) {
    this.isDataLoading = false;
    this.loadingDocuments = false;
    this.loaderLoading = false;
  }
}

async function mounted() {
  try {
    this.loaderLoading = true;
    this.loadingDocuments = true;
    //await this.getMeetingListApi();
    await this.setDefaultFilterApi({ section: "document" });
    this.signalRInit(`meeting_${this.selectedTenant}`);
    this.initializeSortDataAndSignalR("2d0190b7-01b6-4cd5-a05d-a8fb5166a9e4");
    this.loaderLoading = false;
    this.loadingDocuments = false;
  } catch (error) {
    this.loaderLoading = false;
    this.loadingDocuments = false;
  }
}

async function confirmDelete() {
  if (
    await this.$refs.confirm.open(
      this.$t("agenda.hDeleteMessage"),
      this.$t("agenda.lblDeleteMessage")
    )
  ) {
    return true;
  }
}

function getMeetingDescription() {
  let desc =
    '"<p class="paragraph" align="center" style="margin:0in;text-align:center;vertical-align:\nbaseline"><span class="normaltextrun"><span lang="JA" style="font-size:16.0pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif"><strong>２０２２年１月３１日ＡＶＡＮＴ取締役会議題について</strong></span></span><span style="font-size:9.0pt;font-family:&quot;Meiryo UI&quot;"><o:p></o:p></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-fareast-font-family:&quot;Meiryo UI&quot;">&nbsp;</span></span><span style="font-size:9.0pt;font-family:&quot;Meiryo UI&quot;"><o:p></o:p></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="normaltextrun"><span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:\nminor-latin">アバント取締役会メンバーのみなさま</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;\nmso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;<o:p></o:p></span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p>';
  desc =
    desc +
    '<p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="normaltextrun"><span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:\nminor-latin">次回２０２３年１月３１日のアバント取締役会議題についてご連絡いたします。</span></span><span style="font-size:9.0pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;\nmso-fareast-font-family:&quot;Meiryo UI&quot;;mso-hansi-theme-font:minor-latin"><o:p></o:p></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span lang="JA" style="font-size:10.5pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">今回は、まず第</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">2</span></span><span class="eop"><span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-hansi-font-family:\nCentury;mso-hansi-theme-font:minor-latin">四半期決算関連の決議をお願いいたします。その後は１１月・１２月から継続の重要検討事項のディスカッションを行い、最後に時間の許す範囲で各種報告事項をご報告します。全体で</span></span><span class="eop">';
  desc =
    desc +
    '<span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">120</span></span><span class="eop"><span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-hansi-font-family:\nCentury;mso-hansi-theme-font:minor-latin">分程度を予定しております。</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin"><o:p></o:p></span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span lang="JA" style="font-size:10.5pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">決議事項は以下の通りです。</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin"><o:p></o:p></span></span></p>';
  desc =
    desc +
    '<p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l1 level1 lfo1"><!--[if !supportLists]-->①<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span><!--[endif]-->FY22<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">第</span>2<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">四半期決算承認の件</span><span lang="JA"> </span><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>A1<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span><o:p></o:p></p><p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l1 level1 lfo1"><!--[if !supportLists]-->②';
  desc =
    desc +
    '<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span><!--[endif]-->FY22<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">第</span>2<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">四半期の決算短信を東証に提出する件</span><span lang="JA"> </span><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>A2<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】　</span><o:p></o:p></p>';
  desc =
    desc +
    '<p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l1 level1 lfo1"><!--[if !supportLists]-->③<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span><!--[endif]-->FY22<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">第</span>2<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">四半期の四半期報告書を関東財務局に提出する件</span><span lang="JA"> </span><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>A3<span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span><o:p></o:p></p>';
  desc =
    desc +
    '<p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span lang="JA" style="font-size:10.5pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif">第１四半期は、グループ・ガバナンス事業の売上成長に陰りが見られるなど、先行きが多少懸念される決算となりましたが、第</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif">2<span lang="JA">四半期については、すべての事業で前年同期比</span>2<span lang="JA">桁の売上成長を実現するとともに、利益面でも前年同期比</span>150<span lang="JA">％超を実現したデジタルトランスフォーメーション推進事業を筆頭に好調を取り戻しつつある状況です。</span><br>\n<span lang="JA">この結果、単四半期（</span>3<span lang="JA">か月）の連結売上高は</span>xxx<span lang="JA">（</span>xx<span lang="JA">％増）、連結営業利益は</span>xxx<span lang="JA">（</span>xx<span lang="JA">％増）、上期（</span>6<span lang="JA">か月累計）ではそれぞれ</span>xxx<span lang="JA">（</span>xx<span lang="JA">％増）、</span>xxx<span lang="JA">（</span>xx<span lang="JA">％増）といずれも増収増益となっております。</span><br>\n<span lang="JA">※上記の増減率は会計基準差異の調整後の成長率</span><o:p></o:p></span></span></p>';
  desc =
    desc +
    '<p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span lang="JA" style="font-size:10.5pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">続いて、重要検討事項ですが、前回に引き続き「</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">DIVA</span></span><span class="eop"><span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-hansi-font-family:\nCentury;mso-hansi-theme-font:minor-latin">の</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;\nmso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">Succession\nProcess</span></span><span class="eop"><span lang="JA" style="font-size:10.5pt;\nfont-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">の件</span></span><span class="eop"><span lang="JA" style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;\nmso-ascii-theme-font:minor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:\nminor-latin"> </span></span><span class="eop"><span lang="JA" style="font-size:\n10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">S1</span></span><span class="eop">';
  desc =
    desc +
    '<span lang="JA" style="font-size:10.5pt;font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-hansi-font-family:\nCentury;mso-hansi-theme-font:minor-latin">】」となります。すでに一部の役員の方には候補者との面接等に関与いただいており、先月までよりも具体的なイメージを持った議論も可能となりつつある状況であることから、コンセンサスの形成につながるようなディスカッションが出来ればと考えております。</span></span><span class="eop"><span style="font-size:10.5pt;font-family:&quot;Century&quot;,serif;mso-ascii-theme-font:\nminor-latin;mso-fareast-font-family:&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin"><o:p></o:p></span></span></p><p class="paragraph" style="margin:0in;text-align:justify;text-justify:inter-ideograph;\nvertical-align:baseline"><span class="eop"><span style="font-size:10.5pt;\nfont-family:&quot;Century&quot;,serif;mso-ascii-theme-font:minor-latin;mso-fareast-font-family:\n&quot;ＭＳ 明朝&quot;;mso-hansi-theme-font:minor-latin">&nbsp;</span></span></p><p class="MsoNormal"><o:p>&nbsp;</o:p></p><p class="MsoNormal"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">（その他の報告事項）</span><o:p></o:p></p><p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span class="eop">①<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span></span><!--[endif]-->';
  desc =
    desc +
    '<span class="eop">ID</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">社の状況と今後について</span><span lang="JA"> </span></span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>R1</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span><o:p></o:p></span></p><p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span class="eop">②<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span></span><!--[endif]--><span class="eop">US</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">ファンドの運用状況報告</span><span lang="JA"> </span></span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>R2</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span><o:p></o:p></span></p>';
  desc =
    desc +
    '<p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l0 level1 lfo2"><!--[if !supportLists]--><span class="eop">③<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span></span><!--[endif]--><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-fareast-theme-font:minor-fareast;mso-hansi-font-family:Century;\nmso-hansi-theme-font:minor-latin">投資案件（メタプラクシス、</span>ISU</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">）の状況報告</span><span lang="JA"> </span></span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;\nmso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:\nminor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>R3</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span><o:p></o:p></span></p>';
  desc =
    desc +
    '<p class="MsoListParagraph" style="margin-left:.25in;mso-para-margin-left:0gd;\ntext-indent:-.25in;mso-list:l0 level1 lfo2"><!--[if !supportLists]-->④<span style="font-variant-numeric: normal; font-variant-east-asian: normal; font-stretch: normal; font-size: 7pt; line-height: normal; font-family: &quot;Times New Roman&quot;;">&nbsp;&nbsp;&nbsp;\n</span><!--[endif]--><span class="eop"><span lang="JA" style="font-family:\n&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:minor-latin;\nmso-fareast-theme-font:minor-fareast;mso-hansi-font-family:Century;mso-hansi-theme-font:\nminor-latin">業績・財務報告</span><span lang="JA"> </span></span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;\nmso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">【</span>R4</span><span class="eop"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">】</span></span><o:p></o:p></p><p class="MsoNormal"><o:p>&nbsp;</o:p></p><p class="MsoNormal"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:\nCentury;mso-ascii-theme-font:minor-latin;mso-fareast-theme-font:minor-fareast;\nmso-hansi-font-family:Century;mso-hansi-theme-font:minor-latin">以上、よろしくお願いいたします。</span><o:p></o:p></p><p class="MsoNormal"><o:p>&nbsp;</o:p></p><p class="MsoNormal"><o:p>&nbsp;</o:p></p><p>\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n</p><p class="MsoNormal" align="right" style="text-align:right"><span lang="JA" style="font-family:&quot;ＭＳ 明朝&quot;,serif;mso-ascii-font-family:Century;mso-ascii-theme-font:\nminor-latin;mso-fareast-theme-font:minor-fareast;mso-hansi-font-family:Century;\nmso-hansi-theme-font:minor-latin">アバント取締役会議長　森川徹治</span><o:p></o:p></p>"';
  return desc;
}
</script>

<style scoped>
.title {
  font-family: "Noto Sans JP";
  font-style: normal;
  font-weight: 400;
  font-size: 14px !important;
  line-height: 21px;
  color: #ffffff !important;
}
.theme--light.meeting-list:not(.v-list-item--active) .v-list-item__title {
  line-height: 21px !important;
}
::v-deep .theme--light.v-list-item--active .v-list-item__title {
  line-height: 21px !important;
}
::v-deep.v-card__text {
  width: 100%;
  /* padding: 12px !important; */
}

::v-deep .v-btn__content {
  text-transform: none;
  font-size: 0.875rem;
  font-weight: normal;
  font-family: unset;
}
/* default split bar color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal {
  background: var(--v-primaryDark2-base) !important;
  z-index: 1 !important;
  margin-left: 1px;
  margin-right: 1px;
}
.splitterContent
  /deep/
  .e-split-bar.e-split-bar-horizontal.e-resizable-split-bar::after {
  width: 4px !important;
}
/* split bar color in hover and active state */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-hover,
.e-splitter .e-split-bar.e-split-bar-horizontal.e-split-bar-active {
  background: var(--v-primary-base) !important;
}

/* default split bar resize handle color */
::v-deep .e-splitter .e-split-bar.e-split-bar-horizontal .e-resize-handler {
  color: var(--v-primary-base);
}

/* default split bar resize handle color in hover and active state */
::v-deep
  .e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-hover
  .e-resize-handler,
.e-splitter
  .e-split-bar.e-split-bar-horizontal.e-split-bar-active
  .e-resize-handler {
  color: var(--v-primaryDark-base);
}
::v-deep .btn-gray-theme {
  color: #ffffff !important;
  border: 1px solid #ffffff;
  background: transperent;
}
</style>